import { addToast } from "../../toasts";
import { PlatformList, updateImportURL } from "./PlatformList";
import { ImportsModalCtx } from "./ImportsModalCtx";
import { BookingReviews } from "./ManulImport/BookingReviews";
import { AmazonProduct } from "./ManulImport/AmazonProduct";
import { ebay } from "./ManulImport/ebay";
import { Fiverr } from "./ManulImport/Fiverr";
import { Indeed } from "./ManulImport/Indeed";
import { LinkedIn } from "./ManulImport/LinkedIn";
import { Flipkart } from "./ManulImport/Flipkart";
import { Swiggy } from "./ManulImport/Swiggy";
import { Expedia } from "./ManulImport/Expedia";
import { G2 } from "./ManulImport/G2";
import { hotels } from "./ManulImport/hotels";
import { FigmaPluginComments } from "./ManulImport/FigmaPluginComments";
import { MediumComments } from "./ManulImport/MediumComments";
import { ChromeExtension } from "./ManulImport/ChromeExtension";
import { Whop } from "./ManulImport/Whop";
import { Sourceforge } from "./ManulImport/Sourceforge";
import { realtor } from "./ManulImport/realtor";
import { Zillow } from "./ManulImport/Zillow";
import { Glassdoor } from "./ManulImport/Glassdoor";
import { Upwork } from "./ManulImport/Upwork";
import { Freelancer } from "./ManulImport/Freelancer";
import { Capterra } from "./ManulImport/Capterra";
import { Clutch } from "./ManulImport/Clutch";
import { Yelp } from "./ManulImport/Yelp";
import { abia } from "./ManulImport/abia";
import { agoda } from "./ManulImport/agoda";
import { Angi } from "./ManulImport/Angi";
import { ClassPass } from "./ManulImport/ClassPass";
import { EasyWeddings } from "./ManulImport/EasyWeddings";
import { Foursquare } from "./ManulImport/Foursquare";
import { OpenTable } from "./ManulImport/OpenTable";
import { RateMDs } from "./ManulImport/RateMDs";
import { ShopifyAppStore } from "./ManulImport/ShopifyAppStore";
import { ShopifyPartners } from "./ManulImport/ShopifyPartners";
import { ShopifyTheme } from "./ManulImport/ShopifyTheme";
import { SourceForgeProjects } from "./ManulImport/SourceForgeProjects";
import { SourceForgeProducts } from "./ManulImport/SourceForgeProducts";
import { YellowPages } from "./ManulImport/YellowPages";
import { Twitter } from "./ManulImport/Twitter";
import { Youtube } from "./ManulImport/Youtube";
import { VimeoVideo } from "./ManulImport/VimeoVideo";
import { Instagram } from "./ManulImport/Instagram";
import { BetterBusinessBureau } from "./ManulImport/BetterBusinessBureau";
import { Trip } from "./ManulImport/Trip";
import { Avvo } from "./ManulImport/Avvo";
import { TrustRadius } from "./ManulImport/TrustRadius";
import { Influenster } from "./ManulImport/Influenster";
import { MerchantCircle } from "./ManulImport/MerchantCircle";
import { ConsumerAffair } from "./ManulImport/ConsumerAffair";
import { Apartments } from "./ManulImport/Apartments";
import { EdMuds } from "./ManulImport/EdMuds";
import { FindLaw } from "./ManulImport/FindLaw";
import { WebMD } from "./ManulImport/WebMD";
import { Thumbtack } from "./ManulImport/Thumbtack";
import { Houzz } from "./ManulImport/Houzz";
import { HomeAdvisor } from "./ManulImport/HomeAdvisor";
import { Googleshopping } from "./ManulImport/Googleshopping";
import { VRBO } from "./ManulImport/VRBO";
import { ZOCDOC } from "./ManulImport/ZOCDOC";
import { GreatSchools } from "./ManulImport/GreatSchools";
import { DealerRater } from "./ManulImport/DealerRater";
import { CustomerLobby } from "./ManulImport/CustomerLobby";
import { CusRev } from "./ManulImport/CusRev";
import { CreditKarma } from "./ManulImport/CreditKarma";
import { Checkatrade } from "./ManulImport/Checkatrade";
import { Cars } from "./ManulImport/Cars";
import { CarGurus } from "./ManulImport/CarGurus";
import { Bilbayt } from "./ManulImport/Bilbayt";
import { AliExpress } from "./ManulImport/AliExpress";
import { YoutubeComments } from "./LiveAutomation/YoutubeComments/YoutubeComments";
import { GoogleReviews } from "./LiveAutomation/Google/GoogleReviews";
import { PlaystoreReviews } from "./LiveAutomation/PlaystoreReviews/PlaystoreReviews";
import { ProductHuntReviews } from "./LiveAutomation/ProductHunt/ProductHuntReviews";
import { ProductHuntComments } from "./LiveAutomation/ProductHuntComments/ProductHuntComments";
import { CourseraReviews } from "./LiveAutomation/Coursera/CourseraReviews";
import { HealmeReviews } from "./LiveAutomation/Healme/HealmeReviews";
import { ItalkiReviews } from "./LiveAutomation/Italki/ItalkiReviews";
import { OYOReviews } from "./LiveAutomation/OYO/OYOReviews";
import { SkillshareReviews } from "./LiveAutomation/Skillshare/SkillshareReviews";
import { PeoplePerHourReviews } from "./LiveAutomation/PeoplePerHour/PeoplePerHourReviews";
import { ApplePodcastReviews } from "./LiveAutomation/ApplePodcast/ApplePodcastReviews";
import { AppStoreReviews } from "./LiveAutomation/AppStore/AppStoreReviews";
import { UdemyReviews } from "./LiveAutomation/Udemy/UdemyReviews";
import { HomeStarsReviews } from "./LiveAutomation/HomeStars/HomeStarsReviews";
import { AirbnbReviews } from "./LiveAutomation/Airbnb/AirbnbReviews";
import { ThemeForestComments } from "./LiveAutomation/ThemeForestComments/ThemeForestComments";
import { ZomatoReviews } from "./LiveAutomation/Zomato/ZomatoReviews";
import { GoodreadsReviews } from "./LiveAutomation/Goodreads/GoodreadsReviews";
import { FreshaReviews } from "./LiveAutomation/Fresha/FreshaReviews";
import { ThemeForestReviews } from "./LiveAutomation/ThemeForest/ThemeForestReviews";
import { RottenTomatoesReviews } from "./LiveAutomation/RottenTomatoes/RottenTomatoesReviews";
import { RealtorReviews } from "./LiveAutomation/Realtor/RealtorReviews";
import { GumroadReviews } from "./LiveAutomation/Gumroad/GumroadReviews";
import { IMDbReviews } from "./LiveAutomation/IMDb/IMDbReviews";
import { AppSumoReviews } from "./LiveAutomation/AppSumo/AppSumoReviews";
import { TripadvisorReviews } from "./LiveAutomation/Tripadvisor/TripadvisorReviews";
import { WordpressPluginReviews } from "./LiveAutomation/wordpressPlugin/wordpressPluginReviews";
import { TrustpilotReviews } from "./LiveAutomation/Trustpilot/TrustpilotReviews";
import { BookingComAttractionReviews } from "./LiveAutomation/BookingComAttraction/BookingComAttractionReviews";
import { ImportsQuitModal } from "./ImportsQuitModal";
import { HSTabs } from "preline";

export function ImportsModal() {
    let $importModalClose: null | HTMLElement = null;
    let $modalElem: null | HTMLElement = null;
    let $quiteImportModal: null | HTMLButtonElement = null;
    let $currentTabId: string[] = [];

    const children = {
        PlatformList: PlatformList(),
        BookingReviews: BookingReviews(),
        AmazonProduct: AmazonProduct(),
        YoutubeComments: YoutubeComments(),
        ProductHuntReviews: ProductHuntReviews(),
        GoogleReviews: GoogleReviews(),
        PlaystoreReviews: PlaystoreReviews(),
        ProductHuntComments: ProductHuntComments(),
        CourseraReviews: CourseraReviews(),
        HealmeReviews: HealmeReviews(),
        ItalkiReviews: ItalkiReviews(),
        OYOReviews: OYOReviews(),
        SkillshareReviews: SkillshareReviews(),
        PeoplePerHourReviews: PeoplePerHourReviews(),
        AppStoreReviews: AppStoreReviews(),
        HomeStarsReviews: HomeStarsReviews(),
        ZomatoReviews: ZomatoReviews(),
        GoodreadsReviews: GoodreadsReviews(),
        ThemeForestReviews: ThemeForestReviews(),
        RottenTomatoesReviews: RottenTomatoesReviews(),
        RealtorReviews: RealtorReviews(),
        GumroadReviews: GumroadReviews(),
        IMDbReviews: IMDbReviews(),
        AppSumoReviews: AppSumoReviews(),
        TripadvisorReviews: TripadvisorReviews(),
        wordpressPluginReviews: WordpressPluginReviews(),
        TrustpilotReviews: TrustpilotReviews(),
        BookingComAttractionReviews: BookingComAttractionReviews(),
        ebay: ebay(),
        Fiverr: Fiverr(),
        Indeed: Indeed(),
        LinkedIn: LinkedIn(),
        Flipkart: Flipkart(),
        Swiggy: Swiggy(),
        Expedia: Expedia(),
        G2: G2(),
        hotels: hotels(),
        FigmaPluginComments: FigmaPluginComments(),
        MediumComments: MediumComments(),
        ChromeExtension: ChromeExtension(),
        Whop: Whop(),
        Sourceforge: Sourceforge(),
        realtor: realtor(),
        Zillow: Zillow(),
        Glassdoor: Glassdoor(),
        Upwork: Upwork(),
        Freelancer: Freelancer(),
        Capterra: Capterra(),
        Clutch: Clutch(),
        Yelp: Yelp(),
        abia: abia(),
        agoda: agoda(),
        Angi: Angi(),
        ClassPass: ClassPass(),
        EasyWeddings: EasyWeddings(),
        Foursquare: Foursquare(),
        OpenTable: OpenTable(),
        RateMDs: RateMDs(),
        ShopifyAppStore: ShopifyAppStore(),
        ShopifyPartners: ShopifyPartners(),
        ShopifyTheme: ShopifyTheme(),
        SourceForgeProjects: SourceForgeProjects(),
        SourceForgeProducts: SourceForgeProducts(),
        YellowPages: YellowPages(),
        Twitter: Twitter(),
        Youtube: Youtube(),
        VimeoVideo: VimeoVideo(),
        Instagram: Instagram(),
        BetterBusinessBureau: BetterBusinessBureau(),
        Trip: Trip(),
        Avvo: Avvo(),
        TrustRadius: TrustRadius(),
        Influenster: Influenster(),
        MerchantCircle: MerchantCircle(),
        ConsumerAffair: ConsumerAffair(),
        Apartments: Apartments(),
        EdMuds: EdMuds(),
        FindLaw: FindLaw(),
        WebMD: WebMD(),
        Thumbtack: Thumbtack(),
        Houzz: Houzz(),
        HomeAdvisor: HomeAdvisor(),
        Googleshopping: Googleshopping(),
        VRBO: VRBO(),
        ZOCDOC: ZOCDOC(),
        GreatSchools: GreatSchools(),
        DealerRater: DealerRater(),
        CustomerLobby: CustomerLobby(),
        CusRev: CusRev(),
        CreditKarma: CreditKarma(),
        Checkatrade: Checkatrade(),
        Cars: Cars(),
        CarGurus: CarGurus(),
        Bilbayt: Bilbayt(),
        AliExpress: AliExpress(),
        AirbnbReviews: AirbnbReviews(),
        ApplePodcastReviews: ApplePodcastReviews(),
        UdemyReviews: UdemyReviews(),
        FreshaReviews: FreshaReviews(),
        ThemeForestComments: ThemeForestComments(),
        ImportsQuitModal: ImportsQuitModal(),
    };

    function close(isClose: null | boolean = false) {
        const feedboxCardCount = $modalElem ? $modalElem.querySelectorAll('label.feedbox-card').length : 0;
        if (!ImportsModalCtx.getImportProcessRunning() && feedboxCardCount && !isClose) {
            children.ImportsQuitModal.open();
            return;
        }

        if (!ImportsModalCtx.getImportProcessRunning() || isClose) {
            resetCurrentTab();
            return;
        }
        addToast(
            { toastBody: "Please wait for the current import process to finish" },
            "default",
            "error"
        );
    }

    function init() {
        $modalElem = document.getElementById("import-modal");
        $importModalClose = document.getElementById("yt-import-modal-close");
        $quiteImportModal = document.getElementById("import-quit-modal-quit-button") as HTMLButtonElement;
        $importModalClose?.addEventListener("click", () => close());
        $quiteImportModal?.addEventListener("click", () => close(true));

        const el = HSTabs.getInstance('#platform-list > nav') as HSTabs;
        el.on('change', ({ current, prev }: { current: string, prev: string; }) => {
            if (current == prev) return;
            const element = document.querySelector(current) as HTMLElement;
            ImportsModalCtx.showErrorImage(element!,false,false)
            if (!$currentTabId.includes(current)) {
                $currentTabId.push(current);
            }
        });
    }

    function resetCurrentTab() {
        ImportsModalCtx.closeImportsModal();
        updateImportURL(null);
        $currentTabId!.forEach(tabId => {
            var currentTab = document.querySelector(`${tabId}`);
            if (currentTab) {
                const platform = currentTab.getAttribute("data-platform");
                if (!platform) return;
                if (platform) {
                    const platformComponent = children[platform as keyof typeof children];
                    if (platformComponent && typeof (platformComponent as { resetSections?: () => void }).resetSections === 'function'
                    ) {
                        (platformComponent as { resetSections: () => void }).resetSections();
                    }
                }
                currentTab.querySelector("form")?.reset();
            }
        });
        $currentTabId = [];
    }

    function render() {
        return /*html*/ `
            <button id="import-modal-hidden-trigger" aria-haspopup="dialog" aria-expanded="false" aria-controls="hs-full-screen-modal"
                data-hs-overlay="#import-modal" type="button"
                class="hidden">
                Import Modal Hidden Trigger
            </button>
            <div id="import-modal"
                class="hs-overlay hidden size-full fixed top-0 start-0 z-[80] [--overlay-backdrop:static] pointer-events-none"
                data-hs-overlay-backdrop="static"
                data-hs-overlay-keyboard="false"
                role="dialog" tabindex="-1" aria-labelledby="hs-full-screen-label">
                <div
                    class="hs-overlay-open:mt-0 hs-overlay-open:opacity-100 hs-overlay-open:duration-500 mt-10 opacity-0 transition-all max-w-full max-h-full h-full">
                    <div class="flex flex-col bg-[#F9FAFB] pointer-events-auto max-w-full max-h-full h-full dark:bg-neutral-800">
                        <div class="py-3 px-4 bg-white border-b dark:border-neutral-700 dark:bg-neutral-800">
                            <div class="lp:max-w-4xl lp:mx-auto flex justify-between items-center">
                                <h3 id="hs-full-screen-label" class="font-bold text-gray-800 dark:text-white">
                                    Import Reviews
                                </h3>
                                <div class="text-end flex gap-4 items-center">
                                    <button type="button"
                                        id="yt-import-modal-close"
                                        class="size-8 inline-flex justify-center items-center gap-x-2 rounded-full border border-transparent bg-gray-100 text-gray-800 hover:bg-gray-200 focus:outline-none focus:bg-gray-200 disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-700 dark:hover:bg-neutral-600 dark:text-neutral-400 dark:focus:bg-neutral-600">
                                        <span class="sr-only">Close</span>
                                        <svg class="shrink-0 size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round">
                                            <path d="M18 6 6 18"></path>
                                            <path d="m6 6 12 12"></path>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="overflow-y-auto h-[calc(100vh-57px)] bg-[#F9FAFB] dark:bg-neutral-900 p-4 [&::-webkit-scrollbar]:w-1.5
  [&::-webkit-scrollbar-track]:rounded-full
  [&::-webkit-scrollbar-track]:bg-gray-100
  [&::-webkit-scrollbar-thumb]:rounded-full
  [&::-webkit-scrollbar-thumb]:bg-gray-300
  dark:[&::-webkit-scrollbar-track]:bg-neutral-700
  dark:[&::-webkit-scrollbar-thumb]:bg-neutral-500">
                            <div class="lp:max-w-4xl lp:mx-auto">
                                <div class="flex flex-col md:flex-row h-full items-start">
                                    <div
                                        class="group flex flex-col w-full md:max-w-[250px] md:sticky md:top-0 md:min-h-[calc(100vh-90px)] md:max-h-[calc(100vh-90px)]">
                                        <div class="md:pr-4 md:max-h-[calc(100vh-90px)] md:overflow-y-auto [&::-webkit-scrollbar]:w-1.5
        [&::-webkit-scrollbar-track]:rounded-full
        [&::-webkit-scrollbar-track]:[#F9FAFB]
        group-hover:[&::-webkit-scrollbar-track]:bg-gray-100
        [&::-webkit-scrollbar-thumb]:rounded-full
        [&::-webkit-scrollbar-thumb]:[#F9FAFB]
        group-hover:[&::-webkit-scrollbar-thumb]:bg-gray-300
        dark:[&::-webkit-scrollbar-track]:bg-neutral-900
        group-hover:dark:[&::-webkit-scrollbar-track]:bg-neutral-700
        dark:[&::-webkit-scrollbar-thumb]:bg-neutral-900
        group-hover:dark:[&::-webkit-scrollbar-thumb]:bg-neutral-500">
                                            ${children.PlatformList.render()}
                                        </div>
                                    </div>
                                    <div class="flex flex-col items-start w-full gap-4 md:w-[calc(100%-240px)] md:pl-2">
                                        <div class="w-full overflow-x-hidden overflow-y-auto">
                                            <div id="vertical-tab-with-border-01" role="tabpanel" class=""
                                                aria-labelledby="vertical-tab-with-border-item-01" data-platform="GoogleReviews">
                                                ${children.GoogleReviews.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-08" class="hidden" role="tabpanel"
                                                aria-labelledby="vertical-tab-with-border-item-08" data-platform="YoutubeComments">
                                                ${children.YoutubeComments.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-09" class="hidden" role="tabpanel"
                                                aria-labelledby="vertical-tab-with-border-item-09" data-platform="PlaystoreReviews">
                                                ${children.PlaystoreReviews.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-10" class="hidden" role="tabpanel"
                                                aria-labelledby="vertical-tab-with-border-item-10" data-platform="ProductHuntReviews">
                                                ${children.ProductHuntReviews.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-11" class="hidden" role="tabpanel"
                                                aria-labelledby="vertical-tab-with-border-item-11" data-platform="ProductHuntComments">
                                                ${children.ProductHuntComments.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-12" class="hidden" role="tabpanel"
                                                aria-labelledby="vertical-tab-with-border-item-12" data-platform="CourseraReview">
                                                ${children.CourseraReviews.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-13" class="hidden" role="tabpanel"
                                                aria-labelledby="vertical-tab-with-border-item-13" data-platform="HealmeReviews">
                                                ${children.HealmeReviews.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-14" class="hidden" role="tabpanel"
                                                aria-labelledby="vertical-tab-with-border-item-14" data-platform="ItalkiReviews">
                                                ${children.ItalkiReviews.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-15" class="hidden" role="tabpanel"
                                                aria-labelledby="vertical-tab-with-border-item-15" data-platform="OYOReviews">
                                                ${children.OYOReviews.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-16" class="hidden" role="tabpanel"
                                                aria-labelledby="vertical-tab-with-border-item-16" data-platform="SkillshareReviews">
                                                ${children.SkillshareReviews.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-17" class="hidden" role="tabpanel"
                                                aria-labelledby="vertical-tab-with-border-item-17" data-platform="PeoplePerHourReviews">
                                                ${children.PeoplePerHourReviews.render()}
                                            </div>
                                            <div id="vertical-tab-apple-podcast" class="hidden" role="tabpanel"
                                                aria-labelledby="vertical-tab-with-border-item-podcast" data-platform="ApplePodcastReviews">
                                                ${children.ApplePodcastReviews.render()}
                                            </div>
                                            <div id="vertical-tab-zomato" class="hidden" role="tabpanel"
                                                aria-labelledby="vertical-tab-with-border-item-10" data-platform="ZomatoReviews">
                                                ${children.ZomatoReviews.render()}
                                            </div>
                                            
                                            <div id="vertical-tab-udemy" class="hidden" role="tabpanel"
                                                aria-labelledby="vertical-tab-with-border-item-udemy" data-platform="UdemyReviews">
                                                ${children.UdemyReviews.render()}
                                            </div>
                                            
                                            <div id="vertical-tab-fresha" class="hidden" role="tabpanel"
                                                aria-labelledby="vertical-tab-with-border-item-10" data-platform="FreshaReviews">
                                                ${children.FreshaReviews.render()}
                                            </div>

                                            <div id="vertical-tab-with-border-app-store" class="hidden" role="tabpanel" data-platform="AppStoreReviews"
                                                aria-labelledby="vertical-tab-with-border-item-app-store">
                                                ${children.AppStoreReviews.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-homestars" class="hidden" role="tabpanel" data-platform="HomeStarsReviews"
                                                aria-labelledby="vertical-tab-with-border-item-homestars">
                                                ${children.HomeStarsReviews.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-goodreads" class="hidden" role="tabpanel" data-platform="GoodreadsReviews"
                                                aria-labelledby="vertical-tab-with-border-item-goodreads">
                                                ${children.GoodreadsReviews.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-themeforest-reviews" class="hidden" role="tabpanel" data-platform="ThemeForestReviews"
                                                aria-labelledby="vertical-tab-with-border-item-themeforest-reviews">
                                                ${children.ThemeForestReviews.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-rotten-tomatoes" class="hidden" role="tabpanel" data-platform="RottenTomatoesReviews"
                                                aria-labelledby="vertical-tab-with-border-item-rotten-tomatoes">
                                                ${children.RottenTomatoesReviews.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-realtor" class="hidden" role="tabpanel" data-platform="RealtorReviews"
                                                aria-labelledby="vertical-tab-with-border-item-realtor">
                                                ${children.RealtorReviews.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-gumroad" class="hidden" role="tabpanel" data-platform="GumroadReviews"
                                                aria-labelledby="vertical-tab-with-border-item-gumroad">
                                                ${children.GumroadReviews.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-imdb" class="hidden" role="tabpanel" data-platform="IMDbReviews"
                                                aria-labelledby="vertical-tab-with-border-item-imdb">
                                                ${children.IMDbReviews.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-trustpilot" class="hidden" role="tabpanel" data-platform="TrustpilotReviews"
                                                aria-labelledby="vertical-tab-with-border-item-trustpilot">
                                                ${children.TrustpilotReviews.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-booking-com-attraction" class="hidden" role="tabpanel" data-platform="BookingComAttractionReviews"
                                                aria-labelledby="vertical-tab-with-border-item-booking-com-attraction">
                                                ${children.BookingComAttractionReviews.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-appsumo" class="hidden" role="tabpanel" data-platform="AppSumoReviews"
                                                aria-labelledby="vertical-tab-with-border-item-appsumo">
                                                ${children.AppSumoReviews.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-tripadvisor" class="hidden" role="tabpanel" data-platform="TripadvisorReviews"
                                                aria-labelledby="vertical-tab-with-border-item-tripadvisor">
                                                ${children.TripadvisorReviews.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-wordpress-plugin" class="hidden" role="tabpanel" data-platform="wordpressPluginReviews"
                                                aria-labelledby="vertical-tab-with-border-item-wordpress-plugin">
                                                ${children.wordpressPluginReviews.render()}
                                            </div>
                                            <div id="bookingreviews-vertical-tab" class="hidden" role="tabpanel" aria-labelledby="bookingreviews-vertical-tab-item" data-platform="BookingReviews">
                                                ${children.BookingReviews.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-033" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-033" data-platform="AmazonProduct">
                                                ${children.AmazonProduct.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-034" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-034" data-platform="ebay">
                                                ${children.ebay.render()}
                                            </div>                                                  
                                            <div id="vertical-tab-with-border-035" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-035" data-platform="Fiverr">
                                                ${children.Fiverr.render()}
                                            </div>                                                  
                                            <div id="vertical-tab-with-border-036" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-036" data-platform="Indeed">
                                                ${children.Indeed.render()}
                                            </div>                                                                  
                                            <div id="vertical-tab-with-border-037" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-037" data-platform="LinkedIn">
                                                ${children.LinkedIn.render()}
                                            </div>                                                  
                                            <div id="vertical-tab-with-border-038" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-038" data-platform="Flipkart">
                                                ${children.Flipkart.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-039" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-039" data-platform="Swiggy">
                                                ${children.Swiggy.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-040" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-040" data-platform="Expedia">
                                                ${children.Expedia.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-041" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-041" data-platform="G2">
                                                ${children.G2.render()}
                                            </div>                                                  
                                            <div id="vertical-tab-with-border-042" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-042" data-platform="hotels">
                                                ${children.hotels.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-figma" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-figma" data-platform="figma">
                                                ${children.FigmaPluginComments.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-medium-comments" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-medium-comments" data-platform="medium-comments">
                                                ${children.MediumComments.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-043" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-043" data-platform="ChromeExtension">
                                                ${children.ChromeExtension.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-044" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-044" data-platform="Whop">
                                                ${children.Whop.render()}
                                            </div>                                                  
                                            <div id="vertical-tab-with-border-045" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-045" data-platform="Sourceforge">
                                                ${children.Sourceforge.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-046" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-046" data-platform="realtor">
                                                ${children.realtor.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-047" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-047" data-platform="Zillow">
                                                ${children.Zillow.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-048" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-048" data-platform="Glassdoor">
                                                ${children.Glassdoor.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-049" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-049" data-platform="Upwork">
                                                ${children.Upwork.render()}
                                            </div> 
                                            <div id="vertical-tab-with-border-050" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-050" data-platform="Freelancer">
                                                ${children.Freelancer.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-051" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-051" data-platform="Capterra">
                                                ${children.Capterra.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-052" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-052" data-platform="Clutch">
                                                ${children.Clutch.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-053" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-053" data-platform="Yelp">
                                                ${children.Yelp.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-054" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-054" data-platform="abia">
                                                ${children.abia.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-055" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-055" data-platform="agoda">
                                                ${children.agoda.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-056" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-056" data-platform="Angi">
                                                ${children.Angi.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-057" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-057" data-platform="ClassPass">
                                                ${children.ClassPass.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-058" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-058" data-platform="EasyWeddings">
                                                ${children.EasyWeddings.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-059" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-059" data-platform="Foursquare">
                                                ${children.Foursquare.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-060" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-060" data-platform="OpenTable">
                                                ${children.OpenTable.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-061" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-061" data-platform="RateMDs">
                                                ${children.RateMDs.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-062" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-062" data-platform="ShopifyAppStore">
                                                ${children.ShopifyAppStore.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-063" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-063" data-platform="ShopifyPartners">
                                                ${children.ShopifyPartners.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-064" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-064" data-platform="ShopifyTheme">
                                                ${children.ShopifyTheme.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-065" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-065" data-platform="SourceForgeProjects">
                                                ${children.SourceForgeProjects.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-066" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-066" data-platform="SourceForgeProducts">
                                                ${children.SourceForgeProducts.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-067" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-067" data-platform="YellowPages">
                                                ${children.YellowPages.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-068" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-068" data-platform="Twitter">
                                                ${children.Twitter.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-069" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-069" data-platform="Youtube">
                                                ${children.Youtube.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-070" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-070" data-platform="VimeoVideo">
                                                ${children.VimeoVideo.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-071" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-071" data-platform="Instagram">
                                                ${children.Instagram.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-072" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-072" data-platform="BetterBusinessBureau">
                                                ${children.BetterBusinessBureau.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-073" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-073" data-platform="Trip">
                                                ${children.Trip.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-074" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-074" data-platform="Avvo">
                                                ${children.Avvo.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-075" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-075" data-platform="TrustRadius">
                                                ${children.TrustRadius.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-076" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-076" data-platform="Influenster">
                                                ${children.Influenster.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-077" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-077" data-platform="MerchantCircle">
                                                ${children.MerchantCircle.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-078" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-078" data-platform="ConsumerAffair">
                                                ${children.ConsumerAffair.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-079" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-079" data-platform="Apartments">
                                                ${children.Apartments.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-080" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-080" data-platform="EdMuds">
                                                ${children.EdMuds.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-081" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-081" data-platform="FindLaw">
                                                ${children.FindLaw.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-082" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-082" data-platform="WebMD">
                                                ${children.WebMD.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-083" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-083" data-platform="Thumbtack">
                                                ${children.Thumbtack.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-084" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-084" data-platform="Houzz">
                                                ${children.Houzz.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-085" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-085" data-platform="HomeAdvisor">
                                                ${children.HomeAdvisor.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-086" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-086" data-platform="Googleshopping">
                                                ${children.Googleshopping.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-087" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-087" data-platform="VRBO">
                                                ${children.VRBO.render()}
                                            </div>  
                                            <div id="vertical-tab-with-border-088" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-088" data-platform="ZOCDOC">
                                                ${children.ZOCDOC.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-089" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-089" data-platform="GreatSchools">
                                                ${children.GreatSchools.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-090" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-090" data-platform="DealerRater">
                                                ${children.DealerRater.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-090" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-090" data-platform="DealerRater">
                                                ${children.DealerRater.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-091" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-091" data-platform="CustomerLobby">
                                                ${children.CustomerLobby.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-092" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-092" data-platform="CusRev">
                                                ${children.CusRev.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-093" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-093" data-platform="CreditKarma">
                                                ${children.CreditKarma.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-094" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-094" data-platform="Checkatrade">
                                                ${children.Checkatrade.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-095" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-095" data-platform="Cars">
                                                ${children.Cars.render()}
                                            </div>                                            
                                            <div id="vertical-tab-with-border-096" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-096" data-platform="CarGurus">
                                                ${children.CarGurus.render()}
                                            </div>   
                                            <div id="vertical-tab-with-border-097" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-097" data-platform="Bilbayt">
                                                ${children.Bilbayt.render()}
                                            </div>                                                                                                                                    
                                            <div id="vertical-tab-with-border-098" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-098" data-platform="AliExpress">
                                                ${children.AliExpress.render()}
                                            </div>                                            
                                            <div id="vertical-tab-with-border-airbnb" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-airbnb" data-platform="AirbnbReviews">
                                                ${children.AirbnbReviews.render()}
                                            </div>
                                            <div id="vertical-tab-with-border-tfc" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-with-border-item-tfc" data-platform="ThemeForestComments">
                                                ${children.ThemeForestComments.render()}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            ${children.ImportsQuitModal.render()}
        `;
    }

    return {
        init,
        render,
        children,
        close,
    };
}
